







































































































































































































































































import { State, Action, Getter, Mutation } from "vuex-class";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { componentDataType } from "../types";
import { pageDataType } from "../types";
import { HOST, API_URL } from "../global";
import axios from "axios";

const DEFAULT_APPLICATION_DATA: { [key: string]: any } = {
  land: null,
  location_name: "",
  land_address: "",
  land_size: "",
  land_feet: "",
  fullname: "",
  name: "",
  email_address: "",
  contact_number: ""
};
@Component({
  name: "LandownersPage"
})
export default class LandownersPage extends Vue {
  @Getter("pageData") public pageData!: pageDataType;
  @Prop() public compData!: string | null;
  public HOST: string = HOST;
   public errors: any | null;
  public submitted: boolean = false;
  public $validator: any | null;
   public applicationData: { [key: string]: any } = JSON.parse(
    JSON.stringify(DEFAULT_APPLICATION_DATA)
  );
   public mounted() {
    // this.doPageLoad();
    this.applicationData.land = this.pageData.id;
  }
public resetForm() {
    this.applicationData = JSON.parse(JSON.stringify(DEFAULT_APPLICATION_DATA));
    this.applicationData.land = this.pageData.id;
    this.submitted = false;
  }
   public submitForm() {
    this.$validator.validate().then(() => {
    //  console.log(this.errors);

      if (this.errors.items.length == 0) {
        const data = JSON.parse(JSON.stringify(this.applicationData));
        data.land = this.pageData.id;
        const formData = new FormData();
        
         // formData.append("cv", (this.$refs!.cv as any).files[0]);
          Object.keys(data).map((key: string) => {
            formData.append(key, data[key]);
          });
          axios
            .post(`${API_URL}/landowner-form/create/`, formData, {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            })
            .then(resp => {
              this.submitted = true;
            });
        }
      
    });
  }
}
